import React, { useRef } from 'react';
import Projects from './projects';
import { motion as m } from "motion/react"
import { useState, useEffect } from "react";
// import './App.css';
import supabase from './client';
import cloudSprite from './images/sprites/clouds.png';
import arrowImage from './images/symbols/arrow.png';
import pdf from "./types.s";
import concordeCropped from "./images/concordeCompressed3.webp";

// import concordeCropped from "./images/concordeCompressed.png";

// import concordeCropped from "./images/concordeHighRes Cropped.jpg";
// import concordeCropped from "./images/shuttle1.jpg";

import pennLogo from "./images/pennLogo2.png";
import stedsLogo from "./images/faaLogo.png";
import faaLogo from "./images/faaLogo.png";
import djiLogo from "./images/djiLogo.png";
import garminLogo from "./images/garminLogo.png";
import orcaLogo from "./images/logos/organizations/orcaLogo.png";
import llsLogo from "./images/logos/organizations/llsLogo.png";
import penntkdLogo from "./images/logos/organizations/penntkdLogo.jpg";
import cis1200Logo from "./images/logos/organizations/cis1200Logo.png";

import microsoftOffice from "./images/logos/software/officeLogo.png";
import google from "./images/logos/software/googleLogo.png";
import intellij from "./images/logos/software/intellijLogo.png";
import datagrip from "./images/logos/software/datagripLogo.png";
import premirePro from "./images/logos/software/premireLogo.png";
import photoshop from "./images/logos/software/photoshopLogo.png";
import arcGIS from "./images/logos/software/arcgisLogo.png";
import figma from "./images/logos/software/figmaLogo.png";

import testCert from "./images/testCert.png"



import earthNight from "./images/earthNight.png";



import javaLogo from "./images/javaLogo.png";
import ocamlLogo from "./images/logos/languages/ocamlLogo.png";
import cppLogo from "./images/cppLogo.png";
import cLogo from "./images/logos/languages/cLogo.svg";
import matlabLogo from "./images/logos/languages/matlabLogo.png";
import svLogo from "./images/svLogo.webp";
import postgresqlLogo from "./images/logos/languages/postgresqlLogo.png";
import mongodbLogo from "./images/logos/languages/mongodbLogo.png";
import reactLogo from "./images/logos/languages/reactLogo.svg";
import htmlLogo from "./images/htmlLogo.png";
import javascriptLogo from "./images/javascriptLogo.png";



import xplaneLogo from "./images/logos/simulators/xplaneLogo.png";
import xplane12Logo from "./images/logos/simulators/xplane12.png";
import msfsLogo from "./images/logos/simulators/msfsLogo.png";
import redbirdLogo from "./images/logos/simulators/redbirdLogo.webp";


// import autobotLogo from "./images/logos/misc/autobotLogo.png";
// import decepticonLogo from "./images/logos/misc/decepticonLogo.webp";
import contactPageImage from "./images/blackbird1.jpg";
import ScrollProgress from './scrollProgress';

var count = 0;

function openTab(link: string, newTabFlag: boolean) {
  if (newTabFlag) {
    window.open(
      link,
      '_blank'
    );
  } else {
    window.open(
      link,
      '_self'
    );
  }

}

const resumePDF = pdf("documents/resume.pdf");

function download(file: string) {
  const resumePDF = pdf(file);

  //creating an invisible element
  let element = document.createElement('a');
  element.setAttribute('href',
    resumePDF);
  element.setAttribute('download', "Christopher_Powell_Resume");
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

function LandingPage() {
  var pilotStatus = "commercial";
  const [jsonData, setData] = useState<any | null>();
  const videoWasStartedRef = useRef(false);
  const homeSection = useRef(null);
  const aboutSection = useRef(null);
  const resumeSection = useRef(null);
  const projectSection = useRef(null);
  const certificationSection = useRef(null);
  const contactSection = useRef(null);
  const scrollProgress = useRef<HTMLDivElement>(null);
  const copiedModal = useRef<HTMLDivElement>(null);
  const projectRef = useRef<HTMLElement>(null);

  const mobileMenu = useRef<HTMLDivElement>(null);
  const modalVideo = useRef<HTMLDivElement>(null);
  const modalVideoContent = useRef<HTMLVideoElement>(null);


  // const [contentFlag, setFlag] = useState(1);
  const [visitorData, setVisitors] = useState<any | null>();
  // const [videoUrl, setVideoUrl] = useState<string>();
  // const [linkArray, setLinkArray] = useState<string[]>([]);
  // const [scrollY, setScrollY] = useState(0);
  // const [videoWasStarted, setVideoWasStarted] = useState(false);



  const aboutVid1 = useRef<HTMLVideoElement>(null);
  var simulators: [string, string][] = [
    [redbirdLogo, "https://www.redbirdflight.com/"]
    , [xplaneLogo, "https://www.x-plane.com/product/desktop/"],
    [xplane12Logo, "https://www.x-plane.com/"],
    [msfsLogo, "https://www.flightsimulator.com/"]];

  var avionics: [string, string][] = [
    ["garmin g500txi primary flight display", "https://www.garmin.com/en-US/aviation/txi/pfd-mfd/"],
    ["gtn650 gps", "https://www.garmin.com/en-US/p/67884/"],
    ["gma345 audio panel", "https://www.garmin.com/en-US/p/506609/"],
    ["gtx345 transponder", "https://www.garmin.com/en-US/p/140949/"],
    [" gfc 500 autopilot", "https://www.garmin.com/en-US/p/604257/"],
    [" g5 standby instrument display", "https://www.garmin.com/en-US/p/570665/"]
  ]

  var programmingLanguages: [string, string][] = [
    [javaLogo, "https://www.java.com/en/"]
    , [ocamlLogo, "https://ocaml.org/"],
    [cLogo, "https://www.c-language.org/"],
    [cppLogo, "https://isocpp.org/"],
    [matlabLogo, "https://www.mathworks.com/products/matlab.html"],
    [svLogo, "https://en.wikipedia.org/wiki/SystemVerilog"],
    [postgresqlLogo, "https://www.postgresql.org/"],
    [mongodbLogo, "https://www.mongodb.com/"],
    [reactLogo, "https://react.dev/"],
    [htmlLogo, "https://html.spec.whatwg.org/multipage/"],
    [javascriptLogo, "https://developer.mozilla.org/en-US/docs/Web/JavaScript"],];

  var software: [string, string][] = [
    [microsoftOffice, "https://www.microsoft.com/en-us/microsoft-365/microsoft-office"],
    [google, "https://workspace.google.com/"],
    [intellij, "https://www.jetbrains.com/idea/"],
    [datagrip, "https://www.jetbrains.com/datagrip/"],
    [premirePro, "https://www.adobe.com/products/premiere.html"],
    [photoshop, "https://www.adobe.com/products/photoshop.html"],
    [arcGIS, "https://www.arcgis.com/index.html"],
    [figma, "https://www.arcgis.com/index.html"]
  ];

  var certificateData: [string, string][] = [
    [microsoftOffice, "https://www.microsoft.com/en-us/microsoft-365/microsoft-office"],
    [google, "https://workspace.google.com/"],
    [intellij, "https://www.jetbrains.com/idea/"],
    [datagrip, "https://www.jetbrains.com/datagrip/"],
    [premirePro, "https://www.adobe.com/products/premiere.html"],
    [photoshop, "https://www.adobe.com/products/photoshop.html"],
    [arcGIS, "https://www.arcgis.com/index.html"],
    [figma, "https://www.arcgis.com/index.html"]
  ];


  // function vidStart(e: any) {
  //   if (isScrolledIntoView(aboutVid1) && !videoWasStartedRef.current) {
  //     setVideoWasStarted(true);
  //     videoWasStartedRef.current = true;
  //     aboutVid1.current?.play();
  //   }

  // }

  useEffect(() => {
    const queryServer = async () => {
      const { data, error } = await supabase
        .from('projects')
        .select('*').eq('showProject', true).order('highlight', { ascending: false }).order('displayOrder', { ascending: true });

      if (error) {
        //console.log("We had a query error");
      }

      if (data) {
        setData(data)
        // alert(data.statusText as string)
        // //console.log(data)
      }
    }

    queryServer();

    const queryVisitors = async () => {
      const { data, error } = await supabase
        .from('visitors')
        .select('*');

      if (error) {
        //console.log("We had a query error");
      }
      if (data) {
        setVisitors(data)
        // alert(data.statusText as string)
        //console.log(data)
      }
    }

    queryVisitors();
    // initializeLinkArray();
    // advanceVideo();


    // setInterval(queryVisitors, 5000);
    // //console.log(jsonData);
    if (mobileMenu.current) {
      mobileMenu.current.style.display = 'none';
    }


    // const handleScroll = () => {
    //   setScrollY(window.scrollY);
    // };

    // window.addEventListener('scroll', handleScroll);

    var timer: string | number | NodeJS.Timeout | null | undefined = null;
    window.addEventListener('scroll', function () {
      if (timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        if (scrollProgress.current) {
          scrollProgress.current.style.backgroundColor = "";
        }
      }, 150);
    }, false);

    // window.addEventListener('scroll', vidStart);
    window.addEventListener('scroll', scrollProgressGlow);


    // Cleanup the listener on component unmount
    return () => {
      // window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  function scrollProgressGlow() {
    if (scrollProgress?.current) {
      scrollProgress.current.style.backgroundColor = "red";
      scrollProgress.current.style.mask = "linear-gradient(0deg,transparent,90%,blue,100%)"

    }
  }

  async function logVisit() {
    const { error } = await supabase
      .from('visitors')
      .insert({ id: count })
    count += 1;
  }

  function cloudBank() {
    return (
      <div className="cloudBank" style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
        <img src={cloudSprite}></img>
        <img src={cloudSprite}></img>
        <img src={cloudSprite}></img>
        <img src={cloudSprite}></img>
        <img src={cloudSprite}></img>
        <img src={cloudSprite}></img>
        <img src={cloudSprite}></img>
      </div>
    )
  }



  function randomSplashVideo() {

    var tempArray = ["/videos/compressed/shuttle.mp4", "/videos/compressed/shuttle2.mp4", "videos/compressed/interstage.mp4", "videos/compressed/starship1.mp4", "videos/compressed/iss1.mp4", "videos/compressed/iss2.mp4", "videos/compressed/iss3.mp4"];
    var num = Math.floor(Math.random() * tempArray.length);
    var link = tempArray[num];
    return link;
  }

  function deterministicSplashVideo() {
    var tempArray = [["videos/compressed/iss2.mp4", 0],
    ["/videos/compressed/shuttle.mp4", 55],
    ["/videos/compressed/shuttle2.mp4", 0],
    ["videos/compressed/interstage.mp4", 2],
    ["videos/compressed/starship1.mp4", 0],
    ["videos/compressed/iss1.mp4", 0]];
    return (tempArray);
  }

  function handleMetaData(event: React.SyntheticEvent<HTMLVideoElement, Event>, time: number) {
    const videoElement = event.target as HTMLVideoElement;
    videoElement.currentTime = time;
  }

  // function advanceVideo() {
  //   setVideoUrl(randomSplashVideo());
  // }

  function copyToClipboard(text: string) {
    // Get the text
    var copyText = text;

    // Copy the text inside the text field
    navigator.clipboard.writeText(copyText);
    if (copiedModal.current) {
      copiedModal.current.style.display = "flex";

      setTimeout(function () {
        if (copiedModal.current) {
          copiedModal.current.style.display = "none";
        }
      }, 2000);

    }



  }

  function scrollToSection(section: any) {
    section.current?.scrollIntoView({ behavior: "smooth" });
  };

  function isScrolledIntoView(vidRef: React.RefObject<HTMLVideoElement | null>) {
    var elemTop = vidRef.current?.getBoundingClientRect().top;
    var elemBottom = vidRef.current?.getBoundingClientRect().bottom;

    var isVisible = (elemTop ?? 0 >= 0) && (elemBottom ?? 0 <= window.innerHeight);
    return isVisible;
  }

  function toggleMobileMenu() {
    if (mobileMenu.current) {
      if (mobileMenu.current.style.display !== "none") {
        mobileMenu.current.style.display = "none"
      } else {
        mobileMenu.current.style.display = "flex";
      }
    }
  }

  return (
    <m.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, ease: "easeOut" }}>
      <div id="mobileNavMenu" className="landingOverlay" style={{
        position: "fixed", top: "0%", flexDirection: "row", margin: 0, height: "max-content", width: "100vw", maxWidth: "100vw", gap: 5,
        boxSizing: "border-box", alignSelf: "flex-end", padding: 5, overflowWrap: "break-word", flexWrap: "wrap", zIndex: "10000"
      }}>
        <button onClick={() => toggleMobileMenu()}>menu</button>
        <div ref={mobileMenu} className="mobileMenu">
          <button style={{ minWidth: "15vw" }} onClick={() => { scrollToSection(homeSection); toggleMobileMenu(); }}> home</button>
          <button style={{ minWidth: "15vw" }} onClick={() => { scrollToSection(aboutSection); toggleMobileMenu(); }}> about</button>
          <button style={{ minWidth: "15vw" }} onClick={() => { scrollToSection(resumeSection); toggleMobileMenu(); }}>resume</button>
          <button style={{ minWidth: "15vw" }} onClick={() => { scrollToSection(projectSection); toggleMobileMenu(); }}>projects </button>
          <button style={{ minWidth: "15vw" }} onClick={() => { scrollToSection(contactSection); toggleMobileMenu(); }} >contact</button>
          <button style={{ minWidth: "15vw" }} onClick={() => openTab("https://github.com/cs-powell", true)}>github<img style={{ maxWidth: 50, maxHeight: "auto", transform: "rotate(-45deg)" }} src={arrowImage}></img></button>
          <button style={{ minWidth: "15vw" }} onClick={() => openTab("https://www.linkedin.com/in/christopher-powell-5438e", true)} >linkedin <img style={{ maxWidth: 50, maxHeight: "auto", transform: "rotate(-45deg)" }} src={arrowImage}></img></button>
        </div>
      </div>

      <div id="mainPage" className="App">
        <ScrollProgress ref={scrollProgress}></ScrollProgress>
        <div id="desktopNavMenu" className="landingOverlay" style={{
          position: "fixed", top: "20%", flexDirection: "column", margin: 0, height: "max-content", maxHeight: "100%", gap: 20,
          overflow: "auto", boxSizing: "border-box", alignSelf: "flex-end", padding: 20
        }}>
          <button style={{ minWidth: "15vw" }} onClick={() => scrollToSection(homeSection)}> home</button>
          <button style={{ minWidth: "15vw" }} onClick={() => scrollToSection(aboutSection)}> about</button>
          <button style={{ minWidth: "15vw" }} onClick={() => scrollToSection(resumeSection)}>resume</button>
          {/* <button style={{ minWidth: "15vw" }} onClick={() => scrollToSection(certificationSection)}>recent<br></br>certifications </button> */}
          <button style={{ minWidth: "15vw" }} onClick={() => scrollToSection(projectSection)}>projects </button>
          <button style={{ minWidth: "15vw", marginBottom: "1.5rem" }} onClick={() => scrollToSection(contactSection)} >contact</button>
          <button style={{ minWidth: "15vw" }} onClick={() => openTab("https://github.com/cs-powell", true)}>github<img style={{ maxWidth: 50, maxHeight: "auto", transform: "rotate(-45deg)" }} src={arrowImage}></img></button>
          <button style={{ minWidth: "15vw" }} onClick={() => openTab("https://www.linkedin.com/in/christopher-powell-5438e", true)} >linkedin <img style={{ maxWidth: 50, maxHeight: "auto", transform: "rotate(-45deg)" }} src={arrowImage}></img></button>
        </div>



        <div ref={homeSection} className="landing">
          <div className="landingOverlay">
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", flexWrap: "wrap", width: "100%" }}>
              <h1 className="name">christopher</h1>
              <h1 className="name">powell</h1>
            </div>
          </div>

          <div className="landingBackground">
            <img src={concordeCropped}></img>
            {/* <video className="vid" autoPlay playsInline muted loop controls={false}>
              <source src={randomSplashVideo()} />
            </video> */}
          </div>
        </div>


        <div className="aboutPage">
          {/* <img src={concorde}></img> */}
          <div className="aboutPageBackground">
            {
              // deterministicSplashVideo().map((data) => (
              //     <video    className="vid"  poster={concordeCropped} onLoadedMetadata={(e) => handleMetaData(e,data[1] as number)} muted loop controls={false}>
              //       <source src={data[0] as string} />
              //     </video>
              //     // <img style={{backgroundColor:"black"}} src={data}></img>

              // ))
            }
          </div>

          <h1 ref={aboutSection} className="bodyContentHeader"> about me</h1>

          <div className="aboutPageContent">
            {/* Bundle #1 */}
            <div style={{ minHeight: "70vmax" }} className="aboutPageContentBundle">
              <div className="innerBundle">
                <h2>bio</h2>
                <p style={{ fontFamily: "monospace", color: "white", textAlign: "left", lineHeight: "2rem", fontSize: "100%" }}>
                  Christopher is a distinguished graduate of the University of Pennsylvania, where he earned a Bachelor’s degree with dual majors in Computer Science and Cognitive Science with distinction. His undergraduate honors thesis focused on developing a computational cognitive model of pilot performance, showcasing a unique blend of the technical and cognitive expertise.

                  <br></br><br></br>Beyond academics, Christopher was an active member of the Penn Community, performing with the Penn Band and Penn Chamber Brass Quintet, practicing Taekwondo with the Penn Taekwondo Team, and exploring aerospace interests with the Penn Aerospace Club.  Christopher also gained valuable experience over 2 years as a teaching assistant, impacting the hundreds of students enrolled in the <a style={{ color: "white" }} href="https://www.seas.upenn.edu/~cis120/current/" target="_blank">Programming Languages and Techniques</a> course at the University of Pennsylvania.  
                  Additional leadership roles included serving on his high school Model UN Secretariat and spearheading fundraising efforts in a local campaign for the Leukemia and Lymphoma Society.

                  <br></br><br></br>A polyglot, Christopher speaks fluent English, proficient Spanish, and intermediate Mandarin. He holds a 3rd degree black belt in Taekwondo and is both a Part 107 licensced drone pilot and licensed pilot with a {pilotStatus} pilot certificate, instrument rating, and high performance endorsement.

                  {/* With a strong foundation in computer science, cognitive science, and leadership, Christopher is ready to make significant contributions in his chosen field. */}
                </p>
                <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center' }}>
                  {/* <img src={autobotLogo}></img> */}

                  <img src={earthNight}></img>
                  {/* <img src={decepticonLogo}></img> */}
                </div>
              </div>
            </div>


            {/* BUNDLE */}
            <h1 className="bodyContentHeader">education</h1>
            <div className="aboutPageContentBundle">
              <div className="innerBundle">
                {/* <h2>education</h2> */}
                <h3>university of pennsylvania '25 </h3>
                <p>philadelphia</p>

                <img src={pennLogo}></img>

                <p>major in <span style={{ fontWeight: "bolder", fontSize: "1.5rem", color: "#FAD201" }}>computer science</span></p>
                <p>major in <span style={{ fontWeight: "bolder", fontSize: "1.5rem", color: "#FAD201" }}>cognitive science</span></p>
              </div>
            </div>

            {/* BUNDLE */}
            <h1 className="bodyContentHeader">certifications</h1>
            <div className="aboutPageContentBundle">
              <div className="innerBundle">
                {/* <h2>certifications</h2> */}
                <h3 style={{ fontWeight: "bolder", fontSize: "1.5rem" }}>{pilotStatus} pilot</h3>
                <h3>instrument rated</h3>
                <p>280 hours</p>
                <p>high performance endorsement</p>
                <img src={faaLogo}></img>
              </div>
            </div>

            <div className="aboutPageContentBundle">
              <div className="innerBundle">
                <h3>remote pilot certificate</h3>
                <p>licensed under part 107</p>
                <p>experience flying: </p>
                <img src={djiLogo}></img>
              </div>
            </div>

            <h1>experience</h1>
            {/* EXPERIENCE BUNDLE */}
            <div className="aboutPageContentBundle">
              <div className="innerBundle">
                <h2>university of pennsylvania</h2>
                <div className="experienceItem">
                  <div className="experienceColumn">
                    <h3>teaching assistant</h3>
                    <img className="clickableImage" src={cis1200Logo} onClick={() => openTab("https://www.seas.upenn.edu/~cis120/current/", true)}></img>
                  </div>
                  <div className="experienceColumn">
                    <p>programming languages and techniques</p>
                    <div className="genericRow">
                      <img src={ocamlLogo}></img>
                      <img src={javaLogo}></img>
                    </div>
                  </div>

                  <div className="experienceColumn">
                    <p>aug 2023- may 2025</p>
                  </div>

                </div>
              </div>

            </div>

            {/* EXPERIENCE BUNDLE */}
            <div className="aboutPageContentBundle">
              <div className="innerBundle">
                <h2>leadership and volunteer</h2>

                <div className="experienceItem">
                  <div className="experienceColumn">
                    <h3> penn taekwondo</h3>

                    <img className="clickableImage" src={penntkdLogo} onClick={() => openTab("https://penntkd.wixsite.com/penntkd", true)}></img>

                  </div>
                  <div className="experienceItemColumn">
                    <p>webmaster</p>
                    <p> club digital asset management</p>
                  </div>
                  <p>jan 2023 - jan 2025</p>
                </div>


                <div className="experienceItem">
                  <div className="experienceItemColumn">
                    <h3>leukemia and lymphoma society fundraising </h3>
                    <img className="clickableImage" src={llsLogo} onClick={() => openTab("https://www.lls.org/", true)}></img>
                  </div>
                  <div className="experienceItemColumn">
                    <p>team lead</p>
                    <p> <span style={{ fontFamily: 'monospace' }}>$</span>40,000 raised</p>
                  </div>
                  <p>nov 2018 - mar 2019</p>
                </div>

                <div className="experienceItem">
                  <div className="experienceItemColumn">
                    <h3> ocean research and conservation association</h3>
                    <img className="clickableImage" src={orcaLogo} onClick={() => openTab("https://www.teamorca.org/", true)}></img>
                  </div>
                  <div className="experienceItemColumn">
                    <p>volunteer researcher</p>
                    <p> indian river lagoon microplastic collection and analysis</p>
                  </div>
                  <p>jul 2018 - jul 2018</p>
                </div>
              </div>
            </div>

            <h1>skills + proficiency</h1>
            {/* SKILLS BUNDLE */}
            <div className="aboutPageContentBundle">
              <div className="innerBundle">
                <h2>software</h2>
                <div className="experienceItem">
                  {
                    software.map((data, i) => (
                      <div key={i} className="experienceItemColumn">
                        <img className="clickableImage" src={data[0]} onClick={() => openTab(data[1], true)}></img>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>

            {/* SKILLS BUNDLE */}
            <div className="aboutPageContentBundle">
              <div className="innerBundle">
                <h2>programming languages</h2>
                <div className="experienceItem">
                  {
                    programmingLanguages.map((data, i) => (
                      <div key={i} className="experienceItemColumn">
                        <img className="clickableImage" src={data[0]} onClick={() => openTab(data[1], true)}></img>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>




            {/* SKILLS BUNDLE */}
            <div className="aboutPageContentBundle">
              <div className="innerBundle">
                <h2>simulators</h2>
                <div className="experienceItem">
                  {simulators.map((data, i) => (
                    <div key={i} className="experienceItemColumn">
                      <img className="clickableImage" src={data[0]} onClick={() => openTab(data[1], true)}></img>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="aboutPageContentBundle">
              <div className="innerBundle">
                <h2>avionics</h2>
                <div className="experienceItem">
                  <div className="experienceItemColumn">
                    <img src={garminLogo}></img>
                  </div>
                  {
                    avionics.map((data, i) => (
                      <p key={i} className="clickableImage" onClick={() => openTab(data[1], true)}>{data[0]}</p>
                    ))
                  }
                </div>
              </div>
            </div>

            <div className="aboutPageContentBundle">
              <div className="innerBundle">
                <h2>languages</h2>
                <div className="experienceItem">
                  <div className="experienceItemColumn">
                    <h3>english</h3>
                    {/* <p>limited working proficiency</p> */}
                  </div>
                  <div className="experienceItemColumn">
                    {/* <h3>中文</h3> */}
                    <h3>chinese</h3>
                    <p style={{ fontFamily: "monospace" }}>中文</p>
                    {/* <p>limited working proficiency</p> */}
                  </div>
                  <div className="experienceItemColumn">
                    <h3>spanish </h3>
                    <p style={{ fontFamily: "monospace" }}>Español</p>
                    {/* <p>working proficiency</p> */}
                  </div>
                </div>
              </div>
            </div>

            {/* Resume Viewer */}
            <div className="aboutPageContentBundle">
              <iframe ref={resumeSection} src={resumePDF} style={{ width: "100%", minHeight: "50vh", aspectRatio: 8.5 / 11 }} ></iframe>
            </div>




            {/* DOWNLOAD BUTTON */}
            <div className="aboutPageContentBundle">

              <div className="innerBundle">
                {/* <div className="modal">
                <div className="modalContent"> */}
                {/* </div>
                </div> */}
                <button onClick={() => download("documents/resume.pdf")}>download resume</button>
              </div>
            </div>

          </div>
        </div>









        <div className="mainContent">
          <div style={{ backgroundColor: "#0487E2" }} className="cloudScroll">
            <div className="cloudScrollInner">
              {cloudBank()}
              {cloudBank()}
            </div>
          </div>

          {/* <h1 ref={certificationSection} className="sectionHeader">recent certifications <br/>+<br/> courses</h1>
          <div id="certificateGrid" className="certificateGrid">
            {
              certificateData?.map((data: any, i: any) => (
                <div className="certificateWrapper">
                  <h1>Machine Learning</h1>
                  <img src={testCert}></img>
                  <h2>October 2025</h2>
                </div>
              ))
            }
          </div> */}


          <h1 ref={projectSection} className="sectionHeader">recent projects</h1>
          <div id="projectGrid" className="projectGrid">
            {
              jsonData?.map((data: any, i: any) => (
                <Projects handleClick={() => showModalVideo(data.vidPath, data.imgPath)} ref={projectRef} id={data.title} imgPath={data.imgPath} vidPath={data.vidPath} text={data.text} title={data.title} url={data.url} externalResource={data.externalResource}
                  subtitle={data.subtitle} key={i} info={data}></Projects>
              ))
            }
          </div>

         



         


          <div ref={contactSection} className="contactPage">
            <div className="contactPageBackground">
              <img src={contactPageImage}></img>
            </div>

            <div className="contactPageContent">
              <h1>contact me</h1>
              <a href="mailto:cspowell5438@gmail.com" id="email"><p>cspowell5438@gmail.com</p></a>
              <button className="taxiwayButton" onClick={() => copyToClipboard("cspowell5438@gmail.com")}>copy to clipboard</button>
              <div ref={copiedModal} className="copiedModal">
                Copied!
              </div>
              {/* <button className="taxiwayButton" onClick={() => scrollToSection(homeSection)}> scroll to top</button> */}
            </div>
          </div>

          <div ref={modalVideo} className="modalVideo">
            <video ref={modalVideoContent} autoPlay muted controls>
              {/* <source  src="https://xuoohsncmnzqgjytndsy.supabase.co/storage/v1/object/public/assets//cognitiveModel1.mp4"></source> */}
            </video>
            <button className='taxiwayButton' onClick={() => hideModalVideo()}>close window</button>
          </div>


        </div>
      </div>
    </m.div>
  );


  function showModalVideo(src: any, imgSrc: any) {
    if (modalVideo.current && modalVideoContent.current) {
      modalVideo.current.style.display = "flex";
      modalVideoContent.current.poster = imgSrc;
      modalVideoContent.current.src = src;
    }
  }


  function hideModalVideo() {
    if (modalVideo.current && modalVideoContent.current) {
      modalVideo.current.style.display = "none";
      modalVideoContent.current.poster = "";
      modalVideoContent.current.src = "";
    }
  }
}




export default LandingPage;
